/* INTEGY V229 — Desktop Quick Shop structural fix and speed pass — 11JUN2026 */
(function () {
  'use strict';
  if (window.INTEGY_V229_QUICKSHOP_FIX_LOADED) return;
  window.INTEGY_V229_QUICKSHOP_FIX_LOADED = true;

  function mq(q) { try { return window.matchMedia && window.matchMedia(q).matches; } catch (e) { return false; } }
  if (!mq('(min-width: 861px)')) return;

  document.documentElement.classList.add('integy-v229-quickshop-fixed');

  function qsa(sel, root) { try { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); } catch (e) { return []; } }
  function set(el, prop, val) { if (el && el.style) el.style.setProperty(prop, val, 'important'); }

  function fixModal(modal) {
    if (!modal) return;
    modal.classList.add('integy-v229-quickshop-modal');
    set(modal, 'display', 'flex');
    set(modal, 'align-items', 'center');
    set(modal, 'justify-content', 'center');

    qsa('.modal-inner', modal).forEach(function (inner) {
      set(inner, 'width', 'min(1120px, calc(100vw - 80px))');
      set(inner, 'max-width', 'min(1120px, calc(100vw - 80px))');
      set(inner, 'min-width', 'min(960px, calc(100vw - 80px))');
      set(inner, 'height', 'min(760px, calc(100vh - 58px))');
      set(inner, 'max-height', 'min(760px, calc(100vh - 58px))');
      set(inner, 'overflow', 'hidden');
      set(inner, 'box-sizing', 'border-box');
    });

    qsa('.modal-content,[data-modal-content]', modal).forEach(function (content) {
      set(content, 'display', 'block');
      set(content, 'width', '100%');
      set(content, 'max-width', '100%');
      set(content, 'height', '100%');
      set(content, 'max-height', '100%');
      set(content, 'overflow', 'hidden');
    });

    /* The critical fix: container is full-width block; only product--outer is two columns. */
    qsa('.product__container--quick-shop', modal).forEach(function (container) {
      set(container, 'display', 'block');
      set(container, 'width', '100%');
      set(container, 'max-width', '100%');
      set(container, 'min-width', '0');
      set(container, 'height', '100%');
      set(container, 'max-height', '100%');
      set(container, 'min-height', '0');
      set(container, 'overflow', 'hidden');
      set(container, 'margin', '0');
      set(container, 'padding', '0');
    });

    qsa('.product__container--quick-shop > .product--outer,.product--outer', modal).forEach(function (outer) {
      set(outer, 'display', 'grid');
      set(outer, 'grid-template-columns', window.innerWidth < 1120 ? 'minmax(0, 1fr) minmax(330px, 360px)' : 'minmax(0, 650px) minmax(360px, 390px)');
      set(outer, 'gap', '24px');
      set(outer, 'align-items', 'stretch');
      set(outer, 'justify-content', 'center');
      set(outer, 'width', '100%');
      set(outer, 'max-width', '100%');
      set(outer, 'height', '100%');
      set(outer, 'max-height', '100%');
      set(outer, 'min-height', '0');
      set(outer, 'overflow', 'hidden');
    });

    qsa('.product-gallery-wrapper', modal).forEach(function (g) {
      set(g, 'grid-column', '1 / 2');
      set(g, 'width', '100%');
      set(g, 'max-width', '650px');
      set(g, 'height', '100%');
      set(g, 'max-height', '100%');
      set(g, 'min-height', '0');
      set(g, 'overflow', 'hidden');
    });

    qsa('product-gallery.product-gallery', modal).forEach(function (pg) {
      set(pg, 'display', 'flex');
      set(pg, 'flex-wrap', 'wrap');
      set(pg, 'align-content', 'flex-start');
      set(pg, 'width', '100%');
      set(pg, 'height', 'auto');
      set(pg, 'max-height', '100%');
      set(pg, 'overflow', 'hidden');
    });

    qsa('.product-gallery__viewer', modal).forEach(function (viewer) {
      set(viewer, 'width', '100%');
      set(viewer, 'height', 'min(520px, calc(100vh - 210px))');
      set(viewer, 'max-height', 'min(520px, calc(100vh - 210px))');
      set(viewer, 'min-height', '320px');
      set(viewer, 'background', '#fff');
      set(viewer, 'border-radius', '10px');
      set(viewer, 'overflow', 'hidden');
    });

    qsa('.product-gallery__viewer img,.product-gallery__viewer .media__image', modal).forEach(function (img) {
      set(img, 'width', '100%');
      set(img, 'height', '100%');
      set(img, 'object-fit', 'contain');
      set(img, 'background', '#fff');
    });

    qsa('.product-main', modal).forEach(function (main) {
      set(main, 'grid-column', '2 / 3');
      set(main, 'width', '100%');
      set(main, 'max-width', window.innerWidth < 1120 ? '360px' : '390px');
      set(main, 'min-width', '0');
      set(main, 'height', '100%');
      set(main, 'max-height', '100%');
      set(main, 'overflow-y', 'auto');
      set(main, 'overflow-x', 'hidden');
      set(main, 'margin', '0');
    });
  }

  function fixAll() {
    qsa('.modal--quickshop-full,[data-modal-container].modal--quickshop-full').forEach(fixModal);
  }

  function productUrlFromCard(card) {
    if (!card) return '';
    var url = card.getAttribute('data-product-quickshop-url') || card.getAttribute('href') || '';
    if (!url) {
      var link = card.querySelector && card.querySelector('a[href*="/products/"]');
      if (link) url = link.getAttribute('href') || '';
    }
    return url;
  }

  var cache = Object.create(null);
  function prefetchQuickshopUrl(url) {
    if (!url || cache[url]) return;
    if (url.indexOf('/products/') === -1 && url.indexOf('/collections/') === -1) return;
    var qsUrl = url.indexOf('?') >= 0 ? url + '&view=quickshop' : url + '?view=quickshop';
    cache[url] = true;
    try { fetch(qsUrl, { credentials: 'same-origin', priority: 'low' }).catch(function () {}); } catch (e) {}
  }

  function prefetchVisibleCards() {
    qsa('[data-product-quickshop-url], .productgrid--item, .productitem').slice(0, 24).forEach(function(card){
      var url = productUrlFromCard(card);
      if (url) prefetchQuickshopUrl(url);
    });
  }

  document.addEventListener('pointerenter', function(e){
    var t = e.target && e.target.closest && e.target.closest('[data-product-quickshop-url], .productgrid--item, .productitem');
    if (t) prefetchQuickshopUrl(productUrlFromCard(t));
  }, true);
  document.addEventListener('pointerdown', function(e){
    var t = e.target && e.target.closest && e.target.closest('[data-product-quickshop-url], .productgrid--item, .productitem');
    if (t) prefetchQuickshopUrl(productUrlFromCard(t));
    setTimeout(fixAll, 60);
    setTimeout(fixAll, 260);
    setTimeout(fixAll, 800);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ fixAll(); setTimeout(prefetchVisibleCards, 900); }, {once:true});
  else { fixAll(); setTimeout(prefetchVisibleCards, 900); }
  window.addEventListener('pageshow', function(){ setTimeout(fixAll,0); }, {passive:true});
  window.addEventListener('resize', function(){ setTimeout(fixAll,120); }, {passive:true});

  var obs = new MutationObserver(function(){ fixAll(); });
  try { obs.observe(document.documentElement, { childList: true, subtree: true }); } catch(e) {}
  setInterval(fixAll, 700);
})();
